import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d4ri30ss30cg0huicrgg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        setSubmitStatus('error');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      }
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 bg-coral-600 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <span className="font-serif text-2xl font-bold">Security Bay Area</span>
            </div>
            <p className="text-gray-400 mb-6">
              Protecting what matters most with cutting-edge security solutions since 2010.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-coral-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-coral-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-coral-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-coral-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Industries
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/support" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Maintenance Plans
                </Link>
              </li>
              <li>
                <Link to="/technical-support" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Technical Support
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Credentials</h3>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">ACO Licensed</li>
              <li className="text-gray-400 text-sm">CSLB Licensed</li>
              <li className="text-gray-400 text-sm">DUNS Number</li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center border-t border-gray-700 pt-12">
          <div className="rounded-lg overflow-hidden h-32">
            <img 
              src="https://public.readdy.ai/ai/img_res/19ebc830be75dfc901b091faebb2b575.jpg" 
              alt="Security Control Room"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="text-center">
          </div>

          <div>
            <p className="text-gray-400 text-sm mb-3">Stay updated on security trends and company news</p>
            <form 
              onSubmit={handleSubscribe}
              data-readdy-form
              className="flex gap-2"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                disabled={isSubmitting}
                className="flex-1 px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white text-sm focus:outline-none focus:border-primary"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-6 py-2 bg-[#3B82F6] text-white rounded-lg font-medium text-sm hover:bg-[#2563EB] transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            {submitStatus === 'success' && (
              <div className="text-green-400 text-sm flex items-center gap-2 mt-2">
                <i className="ri-check-line"></i>
                Subscribed successfully!
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="text-red-400 text-sm flex items-center gap-2 mt-2">
                <i className="ri-error-warning-line"></i>
                Please enter a valid email
              </div>
            )}
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Security Bay Area. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}